export default __webpack_public_path__ + "img/announcement.2a6eee73.png";